import ConfigProvider from '../ConfigProvider';
import DefaultDateParser from './DefaultDateParser';
import DefaultNumberParser from './DefaultNumberParser';
import NumberFormatInfo from './NumberFormatInfo';
export default class I18NUtils {
    static getDefaultLocale() {
        return Intl.DateTimeFormat().resolvedOptions().locale;
    }
    static getNumberFormatInfo(locale) {
        const formatParts = new Intl.NumberFormat(locale).formatToParts(I18NUtils.PART_FORMAT_TEST_NUMBER);
        return new NumberFormatInfo({
            nativeDigits: new Intl.NumberFormat(locale, { useGrouping: false }).format(9876543210).split('').reverse(),
            numberGroupSeparator: formatParts.find(d => d.type === 'group').value,
            numberDecimalSeparator: formatParts.find(d => d.type === 'decimal').value,
            negativeSign: formatParts.find(d => d.type === 'minusSign').value
        });
    }
    static init() {
        I18NUtils.defaultDateParser = new DefaultDateParser();
        I18NUtils.defaultNumberFormatInfo = I18NUtils.getNumberFormatInfo(ConfigProvider.config.locale);
        I18NUtils.defaultNumberParser = new DefaultNumberParser(I18NUtils.defaultNumberFormatInfo);
    }
}
I18NUtils.PART_FORMAT_TEST_NUMBER = -12345.6;
//# sourceMappingURL=I18NUtils.js.map